import React, { Component } from "react";

import api from "../../../../services/api";
import { Alert, Spin } from "antd";

import DevolucaoField from "./DevolucaoField";

export default class Vermelho extends Component {
  state = {
    error: true,
    tipos: null,
    loading: true,
    devolucao_component: null, // Select "Devolução"
    motivo_component: null, // Select "Motivo"
    submotivo_component: null, // Select "Submotivo"
    tipo_selected: null,
    devolucao_selected: null,
    motivo_selected: null,
    submotivo_selected: null
  };

  async componentDidMount() {
    /** Obtém os motivos da API */

    await api.get("/filtro/motivos/").then(response => {
      this.setState({
        tipos: response.data.tipos,
        error: false
      });
    });

    this.setState({
      loading: false
    });
  }

  /**
   * Controla a alteração da opção "Tipo de devolução"
   */
  handleTypeChange = event => {
    let value = event.target.value;

    // Reseta os campos já visíveis
    this.setState(
      {
        devolucao_component: null,
        devolucao_selected: null,
        motivo_component: null,
        motivo_selected: null,
        submotivo_component: null,
        submotivo_selected: null,
        tipo_selected: null
      },
      () => {
        // Obtém as devoluções de acordo com o tipo de devolução selecionado
        let devolucoes = this.state.tipos.find(dict => dict.tipo_dev == value);

        if (devolucoes) {
          // Seta o componente de devolução
          this.setState({
            devolucao_component: (
              <DevolucaoField
                data={devolucoes.devolucoes.map(value => ({
                  id: value.devolucao_texto,
                  title: value.devolucao_texto
                }))}
                changefn={event => this.handleDevolucaoChange(event)}
                label="Devolução:"
                name="devolucao"
              />
            ),
            tipo_selected: value
          });
        }
      }
    );
  };

  /**
   * Controla a alteração da opção "Devolução"
   */
  handleDevolucaoChange = event => {
    let value = event.target.value;

    // Reseta os campos já visíveis
    this.setState(
      {
        motivo_component: null,
        motivo_selected: null,
        submotivo_component: null,
        submotivo_selected: null
      },
      () => {
        // Pega a devolução selecionada
        let devolucoes = this.state.tipos.find(
          dict => dict.tipo_dev == this.state.tipo_selected
        );
        // Pega os motivos dessa devolução
        let motivos = devolucoes.devolucoes.find(
          dict => dict.devolucao_texto == value
        );

        // Caso a devolução possua motivos
        if (motivos.motivos.length > 0) {
          // Seta o componente de devolução
          this.setState({
            motivo_component: (
              <DevolucaoField
                data={motivos.motivos.map(value => ({
                  id: value.motivo_texto,
                  title: value.motivo_texto
                }))}
                changefn={event => this.handleMotivoDevolucao(event)}
                label="Motivo:"
                name="devolucao_motivo"
              />
            ),
            devolucao_selected: value
          });
        }
      }
    );
  };

  /**
   * Controla a alteração da opção "Motivo de devolução"
   */
  handleMotivoDevolucao = event => {
    let value = event.target.value;

    // Reseta os campos já visíveis
    this.setState(
      {
        submotivo_component: null,
        submotivo_selected: null
      },
      () => {
        /**
         * Verifica se o tipo de devolução selecionado
         * possui motivos
         */
        let devolucoes = this.state.tipos.find(
          dict => dict.tipo_dev == this.state.tipo_selected
        );
        if (devolucoes) {
          let motivos = devolucoes.devolucoes.find(
            dict => dict.devolucao_texto == this.state.devolucao_selected
          );

          if (motivos) {
            let submotivos = motivos.motivos.find(
              dict => dict.motivo_texto == value
            );

            // Caso o motivo possua submotivos
            if (submotivos.submotivos.length > 0) {
              // Seta o componente de submotivos
              this.setState({
                submotivo_component: (
                  <DevolucaoField
                    data={submotivos.submotivos.map(value => ({
                      id: value.submotivo_texto,
                      title: value.submotivo_texto
                    }))}
                    label="Submotivo:"
                    name="submotivo"
                  />
                ),
                motivo_selected: value
              });
            }
          }
        }
      }
    );
  };

  render() {
    if (this.state.loading)
      // Loading
      return (
        <div className="filtro__center_elements">
          <Spin />
        </div>
      );
    if (this.state.error)
      // Erro ao obter os motivos
      return (
        <Alert
          message="Não foi possível obter os motivos de devolução, tente recarregar a página."
          type="error"
        />
      );
    return (
      <div>
        {/** Campo tipo devolução */}
        <DevolucaoField
          changefn={event => this.handleTypeChange(event)}
          data={this.state.tipos.map(value => ({
            id: value.tipo_dev,
            title: value.tipo_dev
          }))}
          label="Tipo devolução:"
          name="tipo_devolucao"
        />
        <br />
        {/** Campo de devolução */}
        {this.state.devolucao_component}
        <br />
        {/** Campo motivo devolução */}
        {this.state.motivo_component}
        <br />
        {/** Campo submotivo */}
        {this.state.submotivo_component}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Vermelho/index.js